//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _DetailPane from './DetailPane';
export const DetailPane = _DetailPane;
export default {DetailPane};

